(function () {
  "use strict";

  // [전시] B2B OBS 구축(BTOCSITE-48265)
  var module = {
    variable: {},
    el: {
      $container: null, // 컨테이너

      $kvSwiperCon: null, // 키비주얼 스와이프
      $prdSwiperCon: null, // 제품리스트 스와이프 (다중)
      $notiSwiperCon: null, // 공지사항 스와이프
      $bestSwiperCon: null, // 인기 있는 제품 스와이프

      $bestCon: null, // 인기 있는 제품 컨테이너
      $bestTab: null, // 인기 있는 제품 카테고리 탭
      $videoSwiperCon: null, // 스토리 동역상 리스트 카테고리 탭 [BTOCSITE-84769] [사업자몰]메인 전시 영역 동영상 삽입
    },
    selector: {
      kvSwiperCon: ".edm-kv-wrap > .swiper",  // 히어로 배너
      prdSwiperCon: ".prd-swiper.swiper", // col, grid 혼합 형태
      notiSwiperCon: ".notice-swiper > .swiper",  // 사용안함

      bestProdCon: ".best-product",
      bestTab: ".tabs-wrap-new",
      videoSwiperCon : ".video-swiper.swiper", // [BTOCSITE-84769] [사업자몰]메인 전시 영역 동영상 삽입
      bestSwiperCon: ".swiper.best-prd-cont", // 컨텐츠
      
      // 구독영역 1, 2, 3 스와이퍼 추가
      subscriptionPrdSwiperCon: "",   // 구독 전시영역 1
      subscriptionBestProdCon: "",    // 구독 전시영역 2 
      
      
    },
    setProperty: function () {
      var container = this.el.$container;

      this.el.$kvSwiperCon = container.find(this.selector.kvSwiperCon);
      this.el.$prdSwiperCon = container.find(this.selector.prdSwiperCon);
      this.el.$bestSwiperCon = container.find(this.selector.bestSwiperCon);
      this.el.$notiSwiperCon = container.find(this.selector.notiSwiperCon);

      this.el.$bestCon = container.find(this.selector.bestProdCon);
      this.el.$bestTab = container.find(this.selector.bestTab);
      this.el.$videoSwiperCon = container.find(this.selector.videoSwiperCon); // [BTOCSITE-84769] [사업자몰]메인 전시 영역 동영상 삽입
    },
    bind: function () {
      this.el.$bestCon.on(
        "smoothscrolltabselecttab",
        this.handler.clickBestTab.bind(this)
      );

      $(window)
        .on("resizeend", this.handler.resize.bind(this))
        .triggerHandler("resize");

      // [S] BTOCSITE-82293 사업자몰(B2B)구독 도입 // 접근성 수정
      // [S] BTOCSITE-77498 [웹앱 접근성 개선활동] B2B 전시_메인 // 스와이프 접근성 커스텀
      $(document).on('focus', 'button, [href], input', function(e) {
        var $focusableEl = $(document.activeElement);

        if (!$focusableEl.closest('.swiper-slide').length) return;

        if ($focusableEl.closest('.prd-swiper').length) {
          var swiper = $focusableEl.closest('.prd-swiper')[0].swiper;

          if (swiper) swiper.slideTo($focusableEl.closest('.swiper-slide').index(), 0);
        }
      });
      // [E] BTOCSITE-77498 [웹앱 접근성 개선활동] B2B 전시_메인 // 스와이프 접근성 커스텀
      // [E] BTOCSITE-82293 사업자몰(B2B)구독 도입 // 접근성 수정
    },
    handler: {
      /**
       * "인기 있는 제품" 클릭 이벤트
       * @param {event} e
       * @param {number} idx // 활성화 idx
       */
      clickBestTab: function (e, idx) {
        var target = $(e.currentTarget);
        var $swiper = target.find("> .swiper");

        if (!!$swiper.length) {
          var swiper = $swiper[0].swiper;

          if (swiper.slides.length > idx) {
            swiper.slideTo(idx);
          }
        }
      },
      /**
       * 리사이징
       */
      resize: function () {
        // 스와이프 리셋
        this.resetSwiper(this.el.$kvSwiperCon);
        
        // 인기 있는 제품 활상화 버튼에 스크롤 위치 갱신
        this.refreshBestTabScroll();
      },
    },
    // 툴팁 옵션 변경 함수
    changeTooltipParent: function (target, value) {
      var targetTooltip = target.vcTooltipTarget('instance', false);

      targetTooltip.option('offsetParentClass', value);
    },
    /**
     * 상단 스와이프 초기화
     */
    initKvSwiper: function () {
      var self = this;

      $(this.selector.kvSwiperCon).vcVideoSwiper({
        swiperOptions: {
          breakpoints: {
            280: {
              centeredSlides: false,
              slidesPerView: 1,
            },
            768: {
              centeredSlides: true,
              slidesPerView: 1,
            },
            1024: { // BTOCSITE-77498
              navigation: {
                nextEl: ".arrow-next",
                prevEl: ".arrow-prev"
              }
            }
          },
          // [S] BTOCSITE-77498 [웹앱 접근성 개선활동] B2B 전시_메인 // aria-label 제거
          on: {
            afterInit: function(swiper) {
              var $swiperEl = $(this.el);
              var $swiperBtn = $swiperEl.find('.slide-arrow > button');
              $swiperBtn.removeAttr('aria-label');
            }
          }
          // [E] BTOCSITE-77498 [웹앱 접근성 개선활동] B2B 전시_메인 // aria-label 제거
        }
      });
    },
    
    /**
     * 제품 리스트 스와이프
     */
    initProductSwiper: function () {
      var self = this;
      //.product-attention
      //.product-recommended (2단)

      this.el.$prdSwiperCon.each(function (idx, el) {
        var $swiper = $(el);
        var isMultiRows = $swiper.parent().hasClass("product-recommended");

        var $next = $swiper.siblings(".swiper-button-next");
        var $prev = $swiper.siblings(".swiper-button-prev");

        // <!-- BTOCSITE-58499
        var slideLen = $swiper.find('.swiper-slide').length;
        var multiRowsPerView = (slideLen === 1) ? 1 :  1.0933;
        // BTOCSITE-58499 -->

        $(this).addClass('swiper-ally-custom'); // [S] BTOCSITE-77498 [웹앱 접근성 개선활동] B2B 전시_메인 // 스와이프 접근성 커스텀

        new Swiper(this, {
          loop: false,
          focusableElements: 'input, select, option, textarea, video, label',
          maxBackfaceHiddenSlides: 0, // 
          navigation: {
            nextEl: !!$next.length ? $next.get(0) : null,
            prevEl: !!$prev.length ? $prev.get(0) : null,
          },
          pagination: {
            el: ".swiper-pagination",
            // [S] BTOCSITE-77498 [웹앱 접근성 개선활동] B2B 전시_메인 // 스와이프 pagination 커스텀
            clickable: true,
            renderBullet: function(index, className) {
              return '<a href="javascript:void(0)" class="' + className + '"><span class="blind">' + (index + 1) + '페이지로 이동</span></a>';
            }
            // [E] BTOCSITE-77498 [웹앱 접근성 개선활동] B2B 전시_메인 // 스와이프 pagination 커스텀
          },
          breakpoints: {
            280: {
              freeMode: {
                enabled: true,
              },
              slidesPerView: isMultiRows ? multiRowsPerView : 2.24,
              slidesPerGroup: 1,
              spaceBetween: isMultiRows ? 0 : 8,
            },
            768: {
              freeMode: {
                enabled: false,
              },
              slidesPerView: isMultiRows ? 1 : 4,
              slidesPerGroup: isMultiRows ? 1 : 4,
              spaceBetween: isMultiRows ? 0 : 24,
            },
          },
          // [S] BTOCSITE-82293 사업자몰(B2B)구독 도입 // 접근성 수정
          a11y: false,
          on: {
            init: function() {
              var $swiperEl = $(this.el);
              var $swiperSlide = $swiperEl.find('.swiper-slide');
              var $swiperPaginationBullet = $swiperEl.find('.swiper-pagination-bullet');
              var $swiperButtonPrev = $swiperEl.siblings('.swiper-button-prev');
              var $swiperButtonNext = $swiperEl.siblings('.swiper-button-next');

              $swiperSlide.each(function(idx) {
                  var $this = $(this);
                  $this.attr('aria-label', (idx+1) +' / '+ $swiperSlide.length);
                  $this.attr('role', 'group');

              });

              $swiperPaginationBullet.each(function(idx) {
                  var $this = $(this);
                  $this.attr('role', 'button');
              });
              
              $swiperButtonPrev.attr('aria-label', '이전');
              $swiperButtonPrev.attr('role', 'button');
              $swiperButtonNext.attr('aria-label', '다음');
              $swiperButtonNext.attr('role', 'button');

              if (!$swiperButtonPrev.hasClass('swiper-button-disabled')) {
                  $swiperButtonPrev.attr('aria-disabled', false);
                  $swiperButtonPrev.attr('tabindex', '0');
              } else {
                  $swiperButtonPrev.attr('aria-disabled', true);
                  $swiperButtonPrev.attr('tabindex', '-1');
              }

              if (!$swiperButtonNext.hasClass('swiper-button-disabled')) {
                  $swiperButtonNext.attr('aria-disabled', false);
                  $swiperButtonNext.attr('tabindex', '0');
              } else {
                  $swiperButtonNext.attr('aria-disabled', true);
                  $swiperButtonNext.attr('tabindex', '-1');
              }

              $swiperButtonPrev.off('keydown').on("keydown",function(key){ 
                  if(key.keyCode==13) {
                      $swiperButtonPrev.click();
                  }
              });
              
              $swiperButtonNext.off('keydown').on("keydown",function(key){ 
                  if(key.keyCode==13) {
                      $swiperButtonNext.click();
                  }
              });
            },
            slideChange: function() {
              var $swiperEl = $(this.el);
              var $swiperButtonPrev = $swiperEl.siblings('.swiper-button-prev');
              var $swiperButtonNext = $swiperEl.siblings('.swiper-button-next');

              $swiperEl.siblings('.swiper-button-disabled').attr('aria-disabled', true);
              $swiperEl.siblings('.swiper-button-disabled').attr('tabindex', '-1')

              if (!$swiperButtonPrev.hasClass('swiper-button-disabled')) {
                  $swiperButtonPrev.attr('aria-disabled', false);
                  $swiperButtonPrev.attr('tabindex', '0');
              }

              if (!$swiperButtonNext.hasClass('swiper-button-disabled')) {
                  $swiperButtonNext.attr('aria-disabled', false);
                  $swiperButtonNext.attr('tabindex', '0');
              }
            }
          }
          // [E] BTOCSITE-82293 사업자몰(B2B)구독 도입 // 접근성 수정
        });
      });

      // [S] BTOCSITE-77498 [웹앱 접근성 개선활동] B2B 전시_메인 // 스와이프 모바일 분기로 인한 사이즈 수정
      $(document).find('.product-recommended.prd-swiper-wrap.mo-only').each(function() {
        var $this = $(this);
        var $wrap = $this.find('.prd-swiper-box');
        var slideLen = $this.find('.prd-swiper-item').length;
        var multiRowsPerView = (slideLen === 1) ? 1 : 1.0933;

        $this.find('.prd-swiper-item').css('width', 'calc(100% / '+multiRowsPerView+')');
      });
      // [E] BTOCSITE-77498 [웹앱 접근성 개선활동] B2B 전시_메인 // 스와이프 모바일 분기로 인한 사이즈 수정
    },
    /**
     * 인기 있는 제품
     */
    initBest: function () {
      this.el.$bestCon.vcSmoothScrollTab({
        tabname: "tabs-wrap-new",
        ctrlname: "contols",
        prevname: "prev",
        nextname: "next",
        tabItem: "ul.tabs > li",
        scrollOption:{
          autoActiveToScroll: true,
          center: false,
          alwaysCheckScroll: true
        },
      });
    },
    /**
     * 인기 있는 제품 스와이프
     */
    initBestSwiper: function () {
      var self = this;

      this.el.$bestSwiperCon.each(function () {
        // 툴팁 옵션 변경
        $(this).find('.ui_tooltip-target').each( function (idx, el) {
          if ($(el).vcTooltipTarget('instance', false)) {
            self.changeTooltipParent($(el), 'btn-area');
          }
        });

        new Swiper(this, {
          effect: "creative",
          focusableElements: 'input, select, option, textarea, video, label',
          creativeEffect: {
            prev: {
              translate: ["-102%", 0, -1],
            },
            next: {
              translate: ["102%", 0, -1],
            },
          },
          loop: false,
          breakpoints: {
            280: {
              spaceBetween: 16,
            },
            768: {
              spaceBetween: 40,
            },
          },
          on: {
            slideNextTransitionStart: function (swiper) {
              self.changeBestSwiper(swiper, "slideNextTransitionStart");
            },
            slidePrevTransitionStart: function (swiper) {
              self.changeBestSwiper(swiper, "slidePrevTransitionStart");
            },
            transitionEnd: function (swiper) {
              self.changeBestSwiper(swiper, "transitionEnd");
            },
            init: function (swiper) {
              self.changeBestSwiper(swiper, "init");
            },
          },
        });
      });
    },
    /**
     * 인기 있는 제품 변경 함수
     * @param {swiper} swiper swiper instance
     * @param {string} type event 타입
     */
    changeBestSwiper: function (swiper, type) {
      // 중간 slide 거치지 않고 바로 이동하기 위함
      if (
        type === "slideNextTransitionStart" ||
        type === "slidePrevTransitionStart"
      ) {
        var jump = Math.abs((swiper.previousIndex || 0) - swiper.realIndex);

        // index 2 이상 이동 // 중간에 껴있는 slide 숨김
        if (jump > 1) {
          if (type === "slideNextTransitionStart") {
            $(swiper.slides)
              .filter(".swiper-slide-prev")
              .css("visibility", "hidden");
          } else if (type === "slidePrevTransitionStart") {
            $(swiper.slides)
              .filter(".swiper-slide-next")
              .css("visibility", "hidden");
          }
        }
      }

      if (type === "transitionEnd") {
        var $container = $(swiper.el).closest(".best-product");

        // 탭 활성화 변경
        var tabIns = $container.vcSmoothScrollTab("instance", false);
        tabIns.setTabIndex(swiper.realIndex);

        // 인기 있는 제품 활상화 버튼에 스크롤 위치 갱신
        this.refreshBestTabScroll(swiper);

        // 중간에 껴있는 slide 숨김 해제
        $(swiper.slides).css("visibility", "");

        $(swiper.el).find('.swiper-slide-active li:first-child a').first().focus(); // BTOCSITE-77498 [웹앱 접근성 개선활동] B2B 전시_메인 // 스와이프 이동 시 포커스
      }

      // [S] BTOCSITE-77498 [웹앱 접근성 개선활동] B2B 전시_메인 // 탭 이동 시 blind 텍스트 수정
      if (type === "transitionEnd" || type === "init") {
        var $container = $(swiper.el).closest(".best-product");
        var $blind = $container.find('.best-prd-cont > .blind');
        var tabIns = $container.vcSmoothScrollTab("instance", false);
        var tabActiveIdx = tabIns.getTabIndex();
        var $tabActiveCont = $container.find('.tabs li').eq(tabActiveIdx);
        var blindText = ($tabActiveCont.find('a')[0].firstChild.nodeValue || '') + ' 탭 내용 시작'

        $blind.text(blindText);
      }
      // [E] BTOCSITE-77498 [웹앱 접근성 개선활동] B2B 전시_메인 // 탭 이동 시 blind 텍스트 수정
    },
    /**
     * 인기 있는 제품 활상화 버튼에 스크롤 위치 갱신
     */
    refreshBestTabScroll: function (swiper) {
      // [S] BTOCSITE-82293 사업자몰(B2B)구독 도입 // 스와이프 추가로 인한 탭 이동 버그 수정
      if (swiper) {
        var $el = $(swiper.$el);
        var scrollIns = $el.prev('.tabs-wrap-new').vcSmoothScroll('instance', false);
        if (scrollIns) scrollIns.scrollToActive();
      } else {
        this.el.$bestTab.each(function() {
          var $this = $(this);
          var scrollIns = $this.vcSmoothScroll('instance', false);
          if (scrollIns) scrollIns.scrollToActive();
        });
      }
      // [E] BTOCSITE-82293 사업자몰(B2B)구독 도입 // 스와이프 추가로 인한 탭 이동 버그 수정
    },
    /**
     * 공지사항 스와이프
     */
    initNotiSwiper: function () {
      var self = this;

      var $swiper = $(this.selector.notiSwiperCon);
      var $controls = $swiper.prev(".top-box").find(".slide-controls");

      var swiper = new Swiper(this.selector.notiSwiperCon, {
        loop: true,
        autoplay: {
          delay: 4500,
          disableOnInteraction: false,
        },
        pagination: {
          el: ".swiper-pagination",
        },
        on: {
          sliderMove: function (swiper) {
            self.changeNotiSwiper(swiper, "sliderMove");
          },
          transitionEnd: function (swiper) {
            self.changeNotiSwiper(swiper, "transitionEnd");
          },
          init: function (swiper) {
            self.changeNotiSwiper(swiper, "init");
          },
        },
      });

      // 공지 < > 버튼
      $controls.on("click", ".controls > button", function (e) {
        e.preventDefault();

        var target = $(e.currentTarget);

        if (swiper) {
          if (target.hasClass("ico-next")) {
            swiper.slideNext();
          } else {
            swiper.slidePrev();
          }
        }
      });
    },
    /**
     * 공지사항 변경 함수
     * @param {swiper} swiper swiper instance
     * @param {string} type event 타입
     */
    changeNotiSwiper: function (swiper, type) {
      var container = swiper.$el;
      var controls = container.prev(".top-box").find(".slide-controls");

      var max = container.find(".swiper-pagination > span").length;
      var idx = container
        .find(".swiper-pagination .swiper-pagination-bullet-active")
        .index();

      controls.find(".current").text(idx + 1);
      controls.find(".count").text(max);

      //if (type === "init") $(swiper.pagination.$el).hide();
    },
    // [S] [BTOCSITE-84769] [사업자몰]메인 전시 영역 동영상 삽입
    /**
     * 스토리 동영상 리스트 스와이프
     */
    initVideoSwiper: function () {
      var self = this;
      this.el.$videoSwiperCon.each(function (idx, el) {
        var $swiper = $(el);
        var $next = $swiper.siblings(".swiper-button-next");
        var $prev = $swiper.siblings(".swiper-button-prev");
        $swiper.addClass('swiper-ally-custom'); // [S] BTOCSITE-77498 [웹앱 접근성 개선활동] B2B 전시_메인 // 스와이프 접근성 커스텀
        new Swiper(this, {
          loop: false,
          focusableElements: 'input, select, option, textarea, video, label',
          navigation: {
            nextEl: !!$next.length ? $next.get(0) : null,
            prevEl: !!$prev.length ? $prev.get(0) : null,
          },
          slidesPerView: 1,
          autoHeight: true,
          a11y: false,
          spaceBetween: 8,
          scrollbar: {
            el: '.swiper-scrollbar',
            draggable: true,
            dragSize:'auto',
            enabled: true,
          },
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
            enabled: false,
          },
          breakpoints: {
            768: {
              slidesPerView: 3,
              spaceBetween: 24,
              slidesPerGroup: 3,
              scrollbar: {
                enabled: false,
              },
              pagination: {
                enabled: true,
                // [S] BTOCSITE-77498 [웹앱 접근성 개선활동] B2B 전시_메인 // 스와이프 pagination 커스텀
                renderBullet: function(index, className) {
                  return '<a href="javascript:void(0)" class="' + className + '"><span class="blind">' + (index + 1) + '페이지로 이동</span></a>';
                }
                // [E] BTOCSITE-77498 [웹앱 접근성 개선활동] B2B 전시_메인 // 스와이프 pagination 커스텀
              },
            },
          },
          a11y: false,
          on: {
            init: function(swiper) {
              var $swiperEl = $(this.el);
              var $swiperSlide = $swiperEl.find('.swiper-slide');
              var $swiperPaginationBullet = $swiperEl.find('.swiper-pagination-bullet');
              var $swiperButtonPrev = $swiperEl.siblings('.swiper-button-prev');
              var $swiperButtonNext = $swiperEl.siblings('.swiper-button-next');

              $swiperSlide.each(function(idx) {
                  var $this = $(this);
                  $this.attr('aria-label', (idx+1) +' / '+ $swiperSlide.length);
                  $this.attr('role', 'group');

              });

              $swiperPaginationBullet.each(function(idx) {
                  var $this = $(this);
                  $this.attr('role', 'button');
                  $this.attr('aria-label', 'Go to slide ' + (idx+1));
              });
              
              $swiperButtonPrev.attr('aria-label', '이전');
              $swiperButtonPrev.attr('role', 'button');
              $swiperButtonNext.attr('aria-label', '다음');
              $swiperButtonNext.attr('role', 'button');

              if (!$swiperButtonPrev.hasClass('swiper-button-disabled')) {
                  $swiperButtonPrev.attr('aria-disabled', false);
                  $swiperButtonPrev.attr('tabindex', '0');
              } else {
                  $swiperButtonPrev.attr('aria-disabled', true);
                  $swiperButtonPrev.attr('tabindex', '-1');
              }

              if (!$swiperButtonNext.hasClass('swiper-button-disabled')) {
                  $swiperButtonNext.attr('aria-disabled', false);
                  $swiperButtonNext.attr('tabindex', '0');
              } else {
                  $swiperButtonNext.attr('aria-disabled', true);
                  $swiperButtonNext.attr('tabindex', '-1');
              }

              $swiperButtonPrev.off('keydown').on("keydown",function(key){ 
                  if(key.keyCode==13) {
                      $swiperButtonPrev.click();
                  }
              });
              
              $swiperButtonNext.off('keydown').on("keydown",function(key){ 
                  if(key.keyCode==13) {
                      $swiperButtonNext.click();
                  }
              });

              // [S] BTOCSITE-77498 [웹앱 접근성 개선활동] B2B 전시_메인 // 스와이프 접근성 커스텀
              $swiperSlide.find('a').on('focus', function(e) {
                var $this = $(this);
                var $slide = $this.closest('.swiper-slide');
                var $slideWrap = $this.closest('.swiper-wrapper');
                $slideWrap.css('display',' block')
                swiper.slideTo($slide.index(), 0)
                $slideWrap.css('display','flex')
              });
              // [E] BTOCSITE-77498 [웹앱 접근성 개선활동] B2B 전시_메인 // 스와이프 접근성 커스텀
            },
            slideChange: function() {
              var $swiperEl = $(this.el);
              var $swiperButtonPrev = $swiperEl.siblings('.swiper-button-prev');
              var $swiperButtonNext = $swiperEl.siblings('.swiper-button-next');

              $swiperEl.siblings('.swiper-button-disabled').attr('aria-disabled', true);
              $swiperEl.siblings('.swiper-button-disabled').attr('tabindex', '-1')

              if (!$swiperButtonPrev.hasClass('swiper-button-disabled')) {
                  $swiperButtonPrev.attr('aria-disabled', false);
                  $swiperButtonPrev.attr('tabindex', '0');
              }

              if (!$swiperButtonNext.hasClass('swiper-button-disabled')) {
                  $swiperButtonNext.attr('aria-disabled', false);
                  $swiperButtonNext.attr('tabindex', '0');
              }
            }
          }
        });
      });
    },
    // [E] [BTOCSITE-84769] [사업자몰]메인 전시 영역 동영상 삽입
    /**
     * 스와이프 리셋
     * @param {jQueryElement} swiperContainer
     */
    resetSwiper: function (swiperContainer) {
      var targetContainer = swiperContainer.hasClass("swiper-initialized")
        ? swiperContainer
        : swiperContainer.find(".swiper-initialized");

      targetContainer.each(
        function (_, el) {
          //swiper 초기화
          var swiper = $(el)[0].swiper;

          if (swiper !== undefined) {
            swiper.destroy(false, true);

            swiper = this.retouchSwiper(swiper);

            new Swiper(swiper.container, swiper.params);
          }
        }.bind(this)
      );
    },
    /**
     * 스와이프 인스턴트 가공 후 반환
     * @param {swiper} swiper
     * @returns
     */
    retouchSwiper: function (swiper) {
      var $realSlides = $(swiper.slides).not(".swiper-slide-duplicate");
      var isOverFlow =
        $realSlides.length > Math.floor(swiper.params.slidesPerView);

      swiper.params.loop = isOverFlow;

      // slide 가 넘지는지 유무
      $(swiper.$el).attr("data-swiper-overflow", isOverFlow);

      return swiper;
    },
    
    /**
     * 로그인 confirm 주입
     * @param {element} a, data-target, id, class etc
     */
    loginConfirm: function() {

    	// 로그인 여부 체크
    	var loginFlag = digitalData.hasOwnProperty("userInfo") && digitalData.userInfo.unifyId ? "Y" : "N";
    	
    	if(loginFlag === 'N'){
    		
	    	// 배열로 대상요소 추가하시면 됩니다.
	    	var selectors = [
	            'a[href*="/business/my-page/estimateRequest"]'
	        ];
	    	
	        // 배열을 문자열로 결합하여 matches에 전달합니다.
	        var combinedSelector = selectors.join(', ');
	         
	    	// 특정 요소들을 수집합니다.
	    	var targets = document.querySelectorAll(combinedSelector);
	
        	// 수집된 각 요소에 대해 loginConfirm을 호출합니다.
            targets.forEach(function(target) {
            	module.grantLoginConfirm(target);
            });
        }
    },
    
    grantLoginConfirm: function(element) {
    	
        // 클릭 이벤트 리스너 추가
        element.addEventListener('click', function(target) {
        	target.preventDefault(); // 기본 동작을 비활성화합니다.
        
            lgkorUI.confirm('', {
                title:'사업자몰 견적문의를 하기 위해 <br> LGE.COM 로그인이 필요합니다. <br> 이동하시겠습니까?',
                okBtnName: '이동',
                cancelBtnName: '취소',
                ok: function() {
                    location.href = element.href;
                }
            }, element); // BTOCSITE-77498 웹접근성
        });
    },
    
    init: function (el) {
      this.el.$container = $(el);

      // console.log("edmHome :: init");

      if (!this.el.$container.length > 0) {
        return;
      }

      this.setProperty();
      this.bind();

      this.inited = this.el.$container !== null;

      // 제품 리스트를 ajax 비동기로 swiper 내부 툴팁 재 초기화 시도
      this.el.$container.find('.ui_tooltip-target').vcTooltipTarget();

      this.initKvSwiper();
      this.initProductSwiper();
      this.initNotiSwiper();

      this.initBest();
      this.initBestSwiper();
      this.initVideoSwiper(); //[BTOCSITE-84769] [사업자몰]메인 전시 영역 동영상 삽입
      this.loginConfirm();
      // console.log("edmHome :: init - complete");
    },
  };

  vcui.require(["ui/smoothScrollTab", "ui/videoSwiper", "ui/tooltipTarget"], function () {
    $(function () {
      // ready
      module.init(".edm-main");
    });
  });
})();
